import React from "react";
import ArtistDirectoryBrowser from "../../components/ArtistDirectoryBrowser.jsx";

export default function ArtistDirectorySection() {
  return (
    <div className="section">
      <div className="label">Browse artists</div>
      <ArtistDirectoryBrowser />
    </div>
  );
}
